'use strict';

angular.module('webmailWrapper')
    .directive('modalClose', function() {
        return {
            restrict: 'E',
            templateUrl: require('@/views/directive/modalClose.html')
        };
    });
